import 'owl.carousel';
$(document).ready(function(){
    var owlservices = $('.owl-services');
    

    owlservices.on('resize.owl.carousel', function(event) {
        if($(window).width() > 991)
            $('.last-active-item').removeClass('last-active-item');
    });
    owlservices.on('translate.owl.carousel', function(event) {
        if($(window).width() > 991)
            $('.last-active-item').removeClass('last-active-item');
    });
    
    owlservices.on('translated.owl.carousel', function(event) {
        if($(window).width() > 991)
            $('.owl-services .owl-item.active').last().addClass('last-active-item');
    });
    owlservices.on('resized.owl.carousel', function(event) {
        if($(window).width() > 991)
            $('.owl-services .owl-item.active').last().addClass('last-active-item');
    });

    
    owlservices.owlCarousel({
        margin: 15,
        loop: true,
        nav: true,
        dotsEach: 1,
        navContainer: "#carousel-navigation",
        navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>'],
        responsive : {
            0 : {
                items:3.2
            },
            400 : {
                items:3.5
            },
            500 : {
                items:4.2
            },
            960 : {
                items:3.5
            },
            1200 : {
                items:4.2
            }
        }
    });

    

    $('.last-active-item').removeClass('last-active-item');
    if($(window).width() > 991)
            $('.owl-services .owl-item.active').last().addClass('last-active-item');
});
